var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessibility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9821 6.994C14.9024 6.664 14.5892 6.472 14.276 6.544C12.9209 6.862 11.4121 7 10 7C8.58795 7 7.0791 6.862 5.72398 6.544C5.41082 6.472 5.09766 6.664 5.01795 6.994C4.93823 7.33 5.13182 7.672 5.44498 7.75C6.36168 7.966 7.3524 8.116 8.29187 8.2V15.4C8.29187 15.73 8.54809 16 8.86125 16C9.17441 16 9.43063 15.73 9.43063 15.4V12.4H10.5694V15.4C10.5694 15.73 10.8256 16 11.1388 16C11.4519 16 11.7081 15.73 11.7081 15.4V8.2C12.6476 8.116 13.6383 7.966 14.5493 7.75C14.8682 7.672 15.0618 7.33 14.9821 6.994ZM10 6.4C10.6263 6.4 11.1388 5.86 11.1388 5.2C11.1388 4.54 10.6263 4 10 4C9.37369 4 8.86125 4.54 8.86125 5.2C8.86125 5.86 9.37369 6.4 10 6.4Z",
    fill: "#647080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z",
    fill: "#647080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibility);
export default __webpack_public_path__ + "static/media/accessibility.f231c07bde412ed589e9a9f46e24ff2b.svg";
export { ForwardRef as ReactComponent };